

import React, { Component } from "react"
import MetaTags from 'react-meta-tags';

import { format } from 'date-fns';
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Breadcrumb,
  BreadcrumbItem,
 
  

} from "reactstrap"
import Select from "react-select"
import axios from 'axios'
import  { Redirect } from 'react-router-dom'
// import $ from "jquery";

import Flatpickr from "react-flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js";

import ReactSelect from 'react-select'
import makeAnimated from 'react-select/animated';
//import BootstrapSelect from "bootstrap-select"

import url from "../../common/api"
import urlApiFile from "../../common/ApiFile"

import { Page, Text,PDFViewer , View, Document, StyleSheet, Line } from '@react-pdf/renderer';

class DocumentPdf extends Component {
    constructor(props) {
        super(props)
        this.state = {
          ressource:{},
          titre:"hello",
          thematique:[],
          mot:[],
          unite:[],
          langue:[],
          systeme:[],
          localite:[],
          type:{},
          auteur:"",
          date_edition:""

        }
        

    }

  componentDidMount(){

      var id=sessionStorage.getItem("idressource")

    fetch(url+"ressources/"+id)
    .then((response) => response.json())
    .then((data) => {
      this.setState({systeme:data.type_systeme_irrigues})
      this.setState({langue:data.langues})
      this.setState({unite:data.unite_administratives})
      this.setState({thematique:data.thematiques})
      this.setState({mot:data.mot_cles})
      this.setState({type:data.type_ressource})
      this.setState({localite:data.pays})
      this.setState({date_edition:data.date_edition})
      this.setState({auteur:data.auteurs})
      this.setState({ressource:data})

    })

  }
    
 render() {
  const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: '#E4E4E4'
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    }
  });


  return (
    
          <Document>
              <Page size="A4"  style={styles.page}>
                <View style={styles.section}>
                  <Text style={{fontSize:16,textAlign:"center",marginTop:"5px",marginBottom:"15px"}}>Fiche de la ressource {this.state.ressource.id}</Text>
                  <Text style={{fontSize:14,textAlign:"center",marginTop:"5px",marginBottom:"15px"}}>{[""+this.state.ressource.nom+""]}</Text>
                  <Text style={{fontSize:12,marginTop:"10px",marginBottom:"5px"}}>Résumé de la Ressource :</Text>
                  <Text style={{fontSize:10,marginLeft:"5px"}}>{this.state.ressource.description}</Text>
                  <Text style={{fontSize:12,marginTop:"10px",marginBottom:"5px"}}>Type de la Ressource :</Text>
                  <Text style={{fontSize:10,marginLeft:"5px"}}>{this.state.type.libelle}</Text>
                  <Text style={{fontSize:12,marginTop:"10px",marginBottom:"5px"}}>Sous-types(s) de la Ressource :</Text>
                  <Text style={{fontSize:12,marginTop:"10px",marginBottom:"5px"}}>Thématiques de la Ressource :</Text>
                   {
                     (this.state.thematique.length!=0)?
                    (this.state.thematique.map((element,idx)=>(
                      <Text style={{fontSize:10,marginLeft:"15px"}}>- {element.libelle}</Text>
                    ))):null

                  }
                  <Text style={{fontSize:12,marginTop:"10px",marginBottom:"5px"}}>Pays(s) :</Text>
                  {
                    (this.state.localite.length!=0)?
                   ( this.state.localite.map((element,idx)=>(
                      <Text style={{fontSize:10,marginLeft:"15px"}}>- {element.nom}</Text>
                    ))):null

                  }

                  <Text style={{fontSize:12,marginTop:"10px" ,marginBottom:"5px"}}>Unité (s) Administrative (s):</Text>
                  {
                    (this.state.unite.length!=0)?
                   ( this.state.unite.map((element,idx)=>(
                      <Text style={{fontSize:10,marginLeft:"15px"}}>- {element.libelle}</Text>
                    ))):null

                  }
                    <Text style={{fontSize:12,marginTop:"10px",marginBottom:"5px"}}>Type(s) Système(s) Irrigué(s):</Text>
                  {
                    (this.state.systeme.length!=0)?
                    (this.state.systeme.map((element,idx)=>(
                      <Text style={{fontSize:10,marginLeft:"15px"}}>- {element.libelle}</Text>
                    ))):null

                  }

                  <Text style={{fontSize:12,marginTop:"10px",marginBottom:"5px"}}>Mot(s) Clé(s) lié(s) à la ressource :</Text>
                  {
                    (this.state.mot.length!=0)?
                    (this.state.mot.map((element,idx)=>(
                      <Text style={{fontSize:10,marginLeft:"15px"}}>- {element.libelle}</Text>
                    ))):null

                  }

                <Text style={{fontSize:12,marginTop:"10px",marginBottom:"5px"}}>Langue(s) liée(s) à la ressource :</Text>
                  {
                    (this.state.langue.length!=0)?
                    (this.state.langue.map((element,idx)=>(
                      <Text style={{fontSize:10,marginLeft:"15px"}}>- {element.nom}</Text>
                    ))):null

                  }

               <Text style={{fontSize:12,marginTop:"10px",marginBottom:"5px"}}>Auteur(s) de à la ressource :</Text>
                {
                    (this.state.auteur.length!=0)?
                    (this.state.auteur.map((element,idx)=>(
                      <Text style={{fontSize:10,marginLeft:"15px"}}>- {element.nom}</Text>
                    ))):null

                  }

                <Text style={{fontSize:12,marginLeft:"400px",marginTop:"20px",marginBottom:"5px"}}>Date d'édition de la ressouce:</Text>
                <Text style={{fontSize:10,marginLeft:"400px",marginTop:"5px"}}>{this.state.date_edition}</Text>
                <Text style={{fontSize:12,marginLeft:"400px",marginTop:"20px",marginBottom:"5px"}}>Auteur(s) :</Text>
               
                 
                </View>

              </Page>
         </Document>
  
        )}

  }
  export default DocumentPdf